import React, { useState, useEffect } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { putApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
// import { toast } from "react-hot-toast";
// import { AcceptDialog } from "../../../components/Elements/DailogBox/AcceptDialog";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";

const SupportReplyDialog = ({ onOpen, onClose, ticketId, onSubmit }) => {
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);
  // const [showAcceptDialog, setShowAcceptDialog] = useState(false);
  const [popup, setPopup] = useState({
    open: false,
    type: "",
    title: "",
    message: "",
  });
  const maxLength = 100;

  const handleSubmit = async () => {
    if (!remarks.trim()) {
      setPopup({
        open: true,
        type: "warning",
        title: "Reply Required",
        message: "Please enter a reply before submitting.",
      });
  
      return;
    }

    try {
      setLoading(true);
      const response = await putApi({
        apiUrl: API_URLS.TICKET_REPLY,
        data: {
          ticketId: ticketId,
          reply: remarks,
        },
      });
      if (response.success) {
        // toast.success("Reply Submitted successfully!");
        setPopup({
          open: true,
          type: "success",
          title: "Reply Sent",
          message: "Reply has been successfully sent.",
        });
        setRemarks("");
      } else {
        setPopup({
          open: true,
          type: "error",
          title: "Failed",
          message: response.message || "Failed to send reply.",
        });
      }
    } catch (error) {
      setPopup({
        open: true,
        type: "error",
        title: "Error",
        message: error.message || "Something went wrong.",
      });
    } finally {
      setLoading(false);
    }
  };

  // const handleAcceptClose = () => {
  //   setShowAcceptDialog(false);
  //   if (onSubmit) onSubmit();
  // };

  useEffect(() => {
    if (popup.open) {
       onClose();
      const timer = setTimeout(() => {
        setPopup((prev) => ({ ...prev, open: false }));
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [popup.open]);

  return (
    <>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D] text-left">
            Reply to Ticket
          </h3>

          <div className="rounded-xl border mt-8 px-12">
            <div className="mt-3 mb-4">
              <hr />
            </div>

            <div className="flex flex-col gap-6">
              <div>
                <label className="block mb-2 font-medium text-gray-700">
                  Remarks
                </label>
                <div className="relative">
                  <textarea
                    placeholder="Type your reply here..."
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    maxLength={maxLength}
                    rows={6}
                    className="w-full p-2 border rounded-md bg-white resize-none"
                  />
                  <div className="absolute bottom-2 right-4 text-xs text-gray-400">
                    {remarks.length}/{maxLength}
                  </div>
                </div>
              </div>

              <div className="flex justify-center gap-6 p-5">
                <CustomButton
                  buttonType="button"
                  variant="ok"
                  buttonText={loading ? "Submitting..." : "Submit"}
                  onClick={handleSubmit}
                  className="text-base font-normal h-[50px] w-[160px]"
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </DailogBox>
      {/* {showAcceptDialog && (
        <AcceptDialog
          open={showAcceptDialog}
          close={handleAcceptClose}
          heading="Reply Sent"
          subheading="Reply has been successfully sent."
          success={true}
        />
      )} */}
      {popup.open && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type={popup.type}
            title={popup.title}
            message={popup.message}
          />
        </div>
      )}
    </>
  );
};

export default SupportReplyDialog;
